(function () {
  var storageKey = 'gelly-wishlist';
  var searchButtons = document.querySelectorAll('.js-search-header');
  var drawer = document.querySelector('[data-gelly-wishlist-drawer]');
  var openButtons = document.querySelectorAll('[data-gelly-wishlist-link]');
  var lastFocus = null;

  searchButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var expanded = document.documentElement.classList.contains('js-drawer-open--search');
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });
  });

  document.addEventListener('predictive-search:close-all', function () {
    searchButtons.forEach(function (btn) {
      btn.setAttribute('aria-expanded', 'false');
    });
  });

  function readWishlist() {
    try {
      var list = JSON.parse(localStorage.getItem(storageKey) || '[]');
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function writeWishlist(list) {
    try {
      localStorage.setItem(storageKey, JSON.stringify(list));
    } catch (e) {}
    updateCounts(list.length);
  }

  function updateCounts(count) {
    document.querySelectorAll('[data-gelly-wishlist-count]').forEach(function (el) {
      if (count) {
        el.textContent = String(count);
        el.removeAttribute('hidden');
      } else {
        el.setAttribute('hidden', '');
      }
    });
  }

  function formatMoney(cents) {
    if (window.theme && theme.Currency) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function buildWishlistCard(product) {
    var image = product.featured_image || (product.images && product.images[0]);
    var imageSrc = image ? image.replace(/(\.jpg|\.png|\.webp)(\?.*)?$/i, '_600x$1$2') : '';
    var price = product.price;
    var compare = product.compare_at_price;
    var priceHtml = formatMoney(price);

    if (compare && compare > price) {
      priceHtml = '<s>' + formatMoney(compare) + '</s> ' + priceHtml;
    }

    return (
      '<article class="gelly-wishlist-card" data-handle="' + product.handle + '">' +
        '<button type="button" class="gelly-wishlist-card__remove" data-gelly-wishlist-remove aria-label="Remove from wishlist">' +
          '<svg width="14" height="14" viewBox="0 0 24 24" aria-hidden="true"><path fill="none" stroke="currentColor" stroke-width="2" d="M6 6l12 12M18 6L6 18"/></svg>' +
        '</button>' +
        '<a href="/products/' + product.handle + '" class="gelly-wishlist-card__link">' +
          '<div class="gelly-wishlist-card__media">' +
            (imageSrc
              ? '<img class="gelly-wishlist-card__image" src="' +
                imageSrc +
                '" alt="' +
                (product.title || '').replace(/"/g, '&quot;') +
                '" loading="lazy" width="600" height="600">'
              : '') +
          '</div>' +
          '<h3 class="gelly-wishlist-card__title">' + product.title + '</h3>' +
          '<p class="gelly-wishlist-card__price">' + priceHtml + '</p>' +
        '</a>' +
      '</article>'
    );
  }

  function renderWishlist() {
    if (!drawer) return;

    var page = drawer.querySelector('[data-gelly-wishlist-page]');
    if (!page) return;

    var grid = page.querySelector('[data-gelly-wishlist-grid]');
    var empty = page.querySelector('[data-gelly-wishlist-empty]');
    var loading = page.querySelector('[data-gelly-wishlist-loading]');
    var handles = readWishlist();

    if (grid) grid.innerHTML = '';
    if (empty) empty.hidden = true;
    if (loading) loading.hidden = false;

    if (!handles.length) {
      if (loading) loading.hidden = true;
      if (empty) empty.hidden = false;
      return;
    }

    Promise.all(
      handles.map(function (handle) {
        return fetch('/products/' + encodeURIComponent(handle) + '.js')
          .then(function (res) {
            if (!res.ok) throw new Error('not found');
            return res.json();
          })
          .catch(function () {
            return null;
          });
      })
    ).then(function (products) {
      var valid = products.filter(Boolean);
      var validHandles = valid.map(function (p) {
        return p.handle;
      });

      if (validHandles.length !== handles.length) {
        writeWishlist(validHandles);
      }

      if (loading) loading.hidden = true;

      if (!valid.length) {
        if (empty) empty.hidden = false;
        return;
      }

      if (empty) empty.hidden = true;
      if (grid) {
        grid.innerHTML = valid.map(buildWishlistCard).join('');
      }
    });
  }

  function openDrawer() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.hidden = false;
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('gelly-wishlist-open');
    openButtons.forEach(function (btn) {
      btn.setAttribute('aria-expanded', 'true');
    });
    renderWishlist();
    var closeBtn = drawer.querySelector('[data-gelly-wishlist-close]');
    if (closeBtn) closeBtn.focus();
  }

  function closeDrawer() {
    if (!drawer || drawer.hidden) return;
    drawer.hidden = true;
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('gelly-wishlist-open');
    openButtons.forEach(function (btn) {
      btn.setAttribute('aria-expanded', 'false');
    });
    if (lastFocus && typeof lastFocus.focus === 'function') {
      lastFocus.focus();
    }
  }

  openButtons.forEach(function (btn) {
    btn.addEventListener('click', function (event) {
      event.preventDefault();
      if (drawer && !drawer.hidden) {
        closeDrawer();
      } else {
        openDrawer();
      }
    });
  });

  if (drawer) {
    drawer.addEventListener('click', function (event) {
      if (event.target.closest('[data-gelly-wishlist-close]')) {
        event.preventDefault();
        closeDrawer();
        return;
      }

      var removeBtn = event.target.closest('[data-gelly-wishlist-remove]');
      if (!removeBtn) return;

      var card = removeBtn.closest('[data-handle]');
      if (!card) return;

      var handle = card.getAttribute('data-handle');
      var list = readWishlist().filter(function (h) {
        return h !== handle;
      });
      writeWishlist(list);
      card.remove();

      if (!list.length) {
        var empty = drawer.querySelector('[data-gelly-wishlist-empty]');
        if (empty) empty.hidden = false;
      }
    });
  }

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeDrawer();
  });

  updateCounts(readWishlist().length);
})();
